import useFavorites from "./hooks/useFavorites";

import FavoriteCard from "./components/FavoriteCard";

import EmptyFavorites from "./components/EmptyFavorites";

import "./Favorites.css";

function Favorites() {

    const {

        favorites,

        loading,

        error,

        toggleFavorite,

    } = useFavorites();

    if (loading) {

        return (

            <div className="favorites-loading">

                Loading Favorites...

            </div>

        );

    }

    if (error) {

        return (

            <div className="favorites-error">

                {error}

            </div>

        );

    }
return (

    <div className="favorites-page">

        <div className="favorites-header">

            <div>

                <h1>

                    ❤️ My Favorites

                </h1>

                <p>

                    All your favorite dishes in one place

                </p>

            </div>

            <div className="favorite-count">

                {favorites.length} Items

            </div>

        </div>

        {

            favorites.length === 0 ? (

                <EmptyFavorites />

            ) : (

                <div className="favorites-list">

                    {

                        favorites.map((favorite) => (

                            <FavoriteCard

                                key={favorite._id}

                                favorite={favorite}

                                onRemove={toggleFavorite}

                            />

                        ))

                    }

                </div>

            )

        }

    </div>

);

}

export default Favorites;